const ITEMS = [
  "C8/10",
  "C12/15",
  "C16/20",
  "C20/25",
  "C25/30",
  "C30/37",
  "C32/40",
  "C40/50",
  "C50/60",
  "LIVRARE LA ȘANTIER",
];

export default function Marquee() {
  return (
    <div data-testid="marquee" className="bg-[#0A0A0A] text-white border-y border-black/20 overflow-hidden">
      <div className="flex marquee-track whitespace-nowrap py-4">
        {[...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
          <span
            key={i}
            className="font-display text-2xl sm:text-3xl tracking-tight uppercase mx-8 flex items-center gap-8"
          >
            {t}
            <span className="w-1.5 h-1.5 bg-[#F59E0B] inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
